<div [class]="'theme-wrapper ' + (theme$ | async)">
  <mat-sidenav-container>
    <mat-sidenav #sidenav mode="push">
      <div class="branding">
        <img [src]="logoalt" [alt]="logoalt"/>
        <!-- <span>{{ 'anms.title.short' | translate}}</span> -->
      </div>
      <!-- Mobile Navigation -->
      <mat-nav-list>
        <!-- <a mat-list-item *ngFor="let item of navigationSideMenu" (click)="sidenav.close()" [routerLink]="[item.link]"routerLinkActive #homeLink="routerLinkActive">
          <mat-icon class="mr-1" color="{{homeLink.isActive ? 'primary': ''}}">home</mat-icon>
          {{item.label | translate}}
        </a> -->
        <a mat-list-item routerLink="home" routerLinkActive #homeLink="routerLinkActive" (click)="sidenav.close()">
          <mat-icon class="mr-1" color="{{homeLink.isActive ? 'primary': ''}}">home</mat-icon>
          Home
        </a>
        <a mat-list-item routerLink="search" routerLinkActive #searchLink="routerLinkActive" (click)="sidenav.close()">
          <mat-icon class="mr-1" color="{{searchLink.isActive ? 'primary': ''}}">search</mat-icon>
          Search
        </a>
        <a mat-list-item routerLink="trends" routerLinkActive #trendLink="routerLinkActive" (click)="sidenav.close()">
          <mat-icon class="pl-1 mr-1" color="{{trendLink.isActive ? 'primary': ''}}">
            <i class="fas fa-hashtag" style="font-size: 18px;"></i>
          </mat-icon>
          <span class="pt-2">Trending</span>
        </a>
        <a mat-list-item routerLink="notifications" *ngIf="isAuthenticated$ | async" routerLinkActive
           #notificationLink="routerLinkActive" (click)="sidenav.close()">
          <mat-icon class="mr-1" color="{{notificationLink.isActive ? 'primary': ''}}">notifications_none</mat-icon>
          Notifications
        </a>

        <a mat-list-item routerLink="dm" *ngIf="isAuthenticated$ | async" routerLinkActive
           #messageLink="routerLinkActive" (click)="sidenav.close() && toggleShowThreads()">
          <mat-icon class="mr-1" color="{{messageLink.isActive ? 'primary': ''}}">email</mat-icon>
          Messages
        </a>

        <a mat-list-item routerLink="groups" *ngIf="(isAuthenticated$ | async)" routerLinkActive
           #groupLink="routerLinkActive" (click)="sidenav.close()">
          <mat-icon class="mr-1" color="{{groupLink.isActive ? 'primary': ''}}">people</mat-icon>
          Groups
        </a>
        <a mat-list-item *ngIf="(settings$ | async)?.theme !== 'DEFAULT-THEME'" (click)="onThemeSelect('DEFAULT-THEME')"
           (click)="sidenav.close()">
          <mat-icon class="mr-1 sun-yellow">wb_sunny</mat-icon>
          Lights On
        </a>

        <a mat-list-item *ngIf="(settings$ | async)?.theme !== 'BLACK-THEME'" (click)="onThemeSelect('BLACK-THEME')"
           (click)="sidenav.close()">
          <mat-icon class="mr-1">nights_stay</mat-icon>
          Lights Off
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <div class="wrapper">
      <div class="toolbar" [style.position]="(stickyHeader$ | async) ? 'fixed' : 'inherit'"
           [class.mat-elevation-z4]="(stickyHeader$ | async)">

        <mat-toolbar color="primary">
          <div class="container d-flex align-content-between">
            <button mat-icon-button class="d-inline d-sm-none" (click)="sidenav.open()">
              <fa-icon icon="bars"></fa-icon>
            </button>
            <button mat-icon-button class="d-none d-sm-inline d-lg-none" (click)="sidenav.open()">
              <fa-icon icon="bars"></fa-icon>
            </button>
            <span routerLink="/" class="branding spacer center d-inline d-sm-none">
              <img [src]="logo" [alt]="logo" class="logo-m"/>
              <sup>beta</sup>
            </span>
            <!-- <span routerLink="/" class="branding spacer center d-none d-sm-inline d-md-none">
              <img [src]="logo" [alt]="logo" />
              <sup>beta</sup>
            </span> -->
            <div class="branding spacer d-flex align-content-start">
              <!-- Logo -->
              <span routerLink="/" class="d-none d-sm-inline pr-3"><img [src]="logo" [alt]="logo"/>
                <sup>beta</sup>
                <!-- <img src="../../assets/icons/ke-flag.png" class="ke-flag"> -->
              </span>

              <!-- Home Button -->
              <!-- <span class="d-none d-md-inline" *ngIf="(isAuthenticated$ | async)">
                <button mat-raised-button color="primary" class="nav-button" *ngFor="let item of navigation"
                  [routerLink]="[item.link]" routerLinkActive="active">
                  <mat-icon>home</mat-icon>
                  {{item.label | translate}}
                </button>
              </span> -->
            </div>

            <!-- Search -->
            <!--            <span class="d-none d-sm-inline mr-2 align-content-center" >-->
            <!--              <input placeholder="Search" type="text" class="form-control">-->
            <!--            </span>-->
            <!-- <button *ngIf="(isAuthenticated$ | async)" mat-icon-button class="d-none d-sm-inline mr-2" matTooltip="Search">
              <mat-icon>search</mat-icon>
            </button> -->

            <!-- Login & Signup Buttons -->
            <button mat-flat-button color="accent" routerLink="auth/login"
                    *ngIf="!(isAuthenticated$ | async)">
              {{ 'anms.menu.login' | translate }}
              <mat-icon>login</mat-icon>
            </button>

            <!-- User Profile -->
            <button *ngIf="(isAuthenticated$ | async)" mat-mini-fab color="primary"
                    [matMenuTriggerFor]="toolbarUserMenu">
              <img class="rounded-circle pr-icon"
                   [src]="(currentUser$ | async)?.profileData.photoURL || './assets/images/profile.jpg'">
            </button>

            <mat-menu #toolbarUserMenu="matMenu" xPosition="after">
              <button mat-menu-item [routerLink]="[(currentUser$ | async)?.handle]">
                <mat-icon>account_box</mat-icon>
                <span>{{ 'anms.menu.profile' | translate }}</span>
              </button>

              <button mat-menu-item routerLink="{{(currentUser$ | async)?.handle}}/settings">
                <mat-icon>settings</mat-icon>
                <span>{{ 'anms.menu.settings' | translate }}</span>
              </button>

              <button mat-menu-item routerLink="{{(currentUser$ | async)?.handle}}/edit">
                <mat-icon>edit</mat-icon>
                <span>{{ 'anms.menu.edit' | translate }}</span>
              </button>

              <button mat-menu-item (click)="onLogoutClick()">
                <mat-icon>exit_to_app</mat-icon>
                <span>{{ 'anms.menu.logout' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </mat-toolbar>
      </div>

      <div class="content"
           [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
        <router-outlet #o="outlet"></router-outlet>
      </div>

      <mat-toolbar color="primary" class="d-flex justify-content-around bottom-nav d-lg-none">
        <button mat-icon-button routerLink="home" routerLinkActive="mat-accent">
          <mat-icon>home</mat-icon>
        </button>
        <button mat-icon-button routerLink="search" routerLinkActive="mat-accent">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button routerLink="trends" routerLinkActive="mat-accent">
          <i class="fas fa-hashtag" style="font-size: 19px;"></i>
        </button>
        <button mat-icon-button routerLink="notifications" *ngIf="isAuthenticated$ | async"
                routerLinkActive="mat-accent">
          <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.notifications !== 0"
                    [matBadge]="(currentUser$ | async)?.unreadNotifications?.notifications?.toString()"
                    matBadgeColor="accent">
            notifications_none
          </mat-icon>

          <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.notifications === 0">
            notifications_none
          </mat-icon>
        </button>
        <button mat-icon-button routerLink="dm" *ngIf="isAuthenticated$ | async" routerLinkActive="mat-accent"
                (click)="toggleShowThreads()">
          <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.messages !== 0"
                    [matBadge]="(currentUser$ | async)?.unreadNotifications?.messages?.toString()"
                    matBadgeColor="accent">email
          </mat-icon>
          <mat-icon *ngIf="(currentUser$ | async)?.unreadNotifications?.messages === 0">email</mat-icon>
        </button>
        <!-- <button mat-icon-button routerLink="groups" *ngIf="isAuthenticated$ | async" routerLinkActive="mat-accent">
          <mat-icon matBadgeColor="accent">people</mat-icon>
        </button> -->
      </mat-toolbar>

      <!-- <div class="footer">
         <div class="row">
          <div class="col-sm-12 links">
            <a href="/feature-list" rel="noopener noreferrer">
              <fa-icon [icon]="['fab','github']"></fa-icon>
              <span>Features</span>
            </a>
            <a href="/examples" rel="noopener noreferrer">
              <fa-icon [icon]="['fab','medium-m']"></fa-icon>
              <span>Examples</span>
            </a>
            <a href="/pages" rel="noopener noreferrer">
              <fa-icon [icon]="['fab','medium-m']"></fa-icon>
              <span>About</span>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12 signature">
            &#169; <small><span class="year">{{year}}</span></small>
            <br class="d-block d-sm-none">
            <a [matTooltip]="'2Bonge Legacy'"
               matTooltipPosition="before"
               target="_blank"
               href="https://2bonge.net">
              <small><fa-icon icon="rocket"></fa-icon></small>
              {{version}} <span *ngIf="!isProd">[{{envName}}]</span>
            </a>
          </div>
        </div>
      </div> -->

    </div>
  </mat-sidenav-container>
</div>
